module.exports = __webpack_public_path__ + "img/chz.9b1baf13.svg";